export const MODAL_TITLE = "Resources settings";
export const DEFAULT_RESOURCES = [
    {
        type:'font',
        active:true,
        name:'Roboto',
        value:'Roboto, Arial, sans-serif',
        external_resource:false,
        position:'head',
        url:'',
    },
    {
        type:'font',
        active:true,
        name:'East Sea Dokdo',
        value:`'East Sea Dokdo', cursive`,
        external_resource:true,
        position:'head',
        url:'https://fonts.googleapis.com/css2?family=East+Sea+Dokdo&display=swap',
        
    },
    {
        type:'font',
        active:true,
        name:'Do Hyeon',
        value:`'Do Hyeon', sans-serif`,
        external_resource:true,
        position:'head',
        url:'https://fonts.googleapis.com/css2?family=Do+Hyeon&display=swap',
    },
    {
        type:'script',
        active:true,
        name:'JQuery',
        external_resource:true,
        position:'footer',
        url:'https://unpkg.com/swiper/swiper-bundle.min.js',
    }
];

